import i18n from "@/language/i18n";

export default {
    ORDERING_GROUP_WRAPPER: {
        type: 'group',
        id: 'ordering',
        label: i18n.t('ModuleRegistry.groups.ordering.name'),
        children: [],
        icon: 'wTime',
        sidebarIcon: '$wNavOrdering'
    },
    CHILDREN: {
        ORDERS_MODULE: {
            type: 'module',
            id: 'orders',
            label: i18n.t('ModuleRegistry.groups.orders.name'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/orders',
        },
        ORDER_SUGGESTIONS_MODULE: {
            type: 'module',
            id: 'externalDemands',
            label: i18n.t('ModuleRegistry.groups.warehouse.orderSuggestions.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/externalDemands',
        }
    }
}